import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useHistory } from 'react-router-dom';

import logo from './../../assets/logo/logo_black.svg'

import Particles from 'react-tsparticles'
import { E164Number, isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js';
import MuiPhoneNumber from 'material-ui-phone-number';

import { useAppDispatch, useAppSelector } from '../../hooks';
import { cognitoSignIn, cognitoSignUp } from '../../managers/redux/slices/authAccount';
import { toast } from 'react-toastify';
import isEmail from 'validator/lib/isEmail';
import queryString from 'query-string'
import { tiers } from '../../constants';
import { Card, CardActions, CardContent, CardHeader } from '@mui/material';
import isURL from 'validator/lib/isURL';
import organization, { createFlourishOrganization } from '../../managers/redux/slices/organization';
import { API } from 'aws-amplify';
import { getLocation } from '../../managers/graphql/queries';
import { Address } from '../../API';

function Copyright(props: any) {
    return (
        <Typography variant="body2" color="text.secondary" align="center" {...props}>
            {'Copyright © '}
            <Link color="inherit" href="https://flourishos.com">
                Flourish, LLC
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

export default function OrganizationRegistration() {

    const dispatch = useAppDispatch()

    const history = useHistory()

    const [screenType, setScreenType] = useState<'create' | 'select-subscription'>('create')

    const [phoneNumber, setPhoneNumber] = useState<E164Number | undefined>(undefined)
    const [organizationName, setOrganizationName] = useState<string | null>(null)
    const [organizationShortName, setOrganizationShortName] = useState<string | null>(null)
    const [address, setAddress] = useState<null | string>(null)
    const [zip, setZip] = useState<null | string>(null)
    const [city, setCity] = useState<null | string>(null)
    const [website, setWebsite] = useState<null | string>(null)

    const [invalidOrganizationName, setInvalidOrganizationName] = useState<boolean>(false)
    const [invalidOrganizationPhoneNumber, setInvalidOrganizationPhoneNumber] = useState<boolean>(false)
    const [invalidAddress, setInvalidAddress] = useState<boolean>(false)
    const [invalidZip, setInvalidZip] = useState<boolean>(false)
    const [invalidCity, setInvalidCity] = useState<boolean>(false)
    const [invalidWebsite, setInvalidWebsite] = useState<boolean>(false)

    const [verifyPhoneNumberNumber, setVerifyPhoneNumberNumber] = useState<E164Number | undefined>(undefined)
    const [verificationCode, setVerificationCode] = useState<string | null>(null)
    const [verifyPhoneNumberPassword, setVerifyPhoneNumberPassword] = useState<string | null>(null)

    const authAccount = useAppSelector(state => state.authAccount.data)
    const selectedStaffProfile = useAppSelector(state => state.authAccount.selectedStaffProfile)

    useEffect(() => {
        const parsed = queryString.parse(window.location.search)
        if (parsed && parsed.t) {
            if (parsed.t == 'create') setScreenType('create')
            else if (parsed.t == 'select-subscription') setScreenType('select-subscription')
        }
    }, [])

    useEffect(() => {
        (async () => {
            if (selectedStaffProfile && selectedStaffProfile.organization) {
                const organization = selectedStaffProfile.organization
                console.log(organization)

                var organizationAddress: Address | null = null

                if (organization.locationID) {
                    const { data }: any = await API.graphql({
                        query: getLocation,
                        variables: {
                            id: organization.locationID
                        }
                    })

                    if (data && data.getLocation && data.getLocation.address) {
                        organizationAddress = data.getLocation.address
                    }
                }

                setOrganizationName(organization.name)
                setWebsite(organization.website ? organization.website : null)
                setOrganizationShortName(organization.shortName ? organization.shortName : null)
                setAddress(organizationAddress && organizationAddress.streetAddress ? organizationAddress.streetAddress : null)
                setZip(organizationAddress && organizationAddress.zip ? organizationAddress.zip : null)
                setCity(organizationAddress && organizationAddress.city ? organizationAddress.city : null)
                setPhoneNumber(organization.phoneNumber && isValidPhoneNumber(organization.phoneNumber) ? parsePhoneNumber(organization.phoneNumber).number : undefined)
            }
        })()
    }, [selectedStaffProfile])

    function handleContinueButtonClick() {
        if (phoneNumber && phoneNumber != '' && isValidPhoneNumber(phoneNumber)) setInvalidOrganizationPhoneNumber(false); else setInvalidOrganizationPhoneNumber(true);
        if (organizationName && organizationName != '') setInvalidOrganizationName(false); else setInvalidOrganizationName(true);
        if (website && website != '' && isURL(website)) setInvalidWebsite(false); else setInvalidWebsite(true);
        if (address && address != '') setInvalidAddress(false); else setInvalidAddress(true);
        if (zip && zip != '' && zip.length == 5) setInvalidZip(false); else setInvalidZip(true);
        if (city && city != '') setInvalidCity(false); else setInvalidCity(true);

        if (phoneNumber && phoneNumber != '' && isValidPhoneNumber(phoneNumber) && organizationName && organizationName != '' && website && website != '' && isURL(website) && address && address != '' && zip && zip != '' && zip.length == 5 && city && city != '') {
            dispatch(createFlourishOrganization({
                name: organizationName,
                shortName: organizationShortName ? organizationShortName : undefined,
                address: {
                    streetAddress: address,
                    city: city,
                    zip: zip
                },
                website: website,
                phoneNumber: phoneNumber.toString(),
            }))
        }
    }

    return (
        <Grid container component="main" sx={{ height: '100vh' }}>
            <CssBaseline />
            {
                screenType == 'create' && selectedStaffProfile == null ?
                    <Grid item xs={12} component={Paper} sx={{ backgroundColor: 'white', zIndex: 1 }} elevation={6} square>
                        <Box
                            sx={{
                                my: 8,
                                mx: 5,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center'
                            }}
                        >
                            <Typography variant="h3" className="my-5">
                                Register your Organization
                            </Typography>
                            <div className="row w-100">
                                <div className="col-12 col-lg-6 my-2">
                                    <MuiPhoneNumber
                                        defaultCountry={'us'}
                                        name="phoneNumber"
                                        type="tel"
                                        countryCodeEditable={false}
                                        onChange={(e) => { console.log(e); if (typeof e == 'string' && isValidPhoneNumber(e)) setPhoneNumber(parsePhoneNumber(e).number); else setPhoneNumber(undefined) }}
                                        variant="outlined"
                                        placeholder="Organization Phone Number"
                                        required
                                        fullWidth
                                        label="Organization Phone Number"
                                        error={invalidOrganizationPhoneNumber}
                                        helperText={invalidOrganizationPhoneNumber ? "Your organization's primary contact phone number is required." : ''}
                                    />
                                </div>
                                <div className="col-12 col-lg-6 my-2">
                                    <TextField
                                        fullWidth
                                        name="Website"
                                        label="Website"
                                        id="Website"
                                        autoComplete="url"
                                        variant="outlined"
                                        onChange={e => setWebsite(e.target.value)}
                                        error={invalidWebsite}
                                        helperText={invalidWebsite ? "Your organization's website is required. A social media page will work if you don't have a dedicated website." : ''}
                                    />
                                </div>
                                <div className="col-12 col-lg-6 my-2">
                                    <TextField
                                        required
                                        fullWidth
                                        id="organizationName"
                                        label="Organization Name"
                                        name="Organization Name"
                                        defaultValue={organizationName}
                                        autoComplete="organization"
                                        variant="outlined"
                                        onChange={e => setOrganizationName(e.target.value)}
                                        error={invalidOrganizationName}
                                        helperText={invalidOrganizationName ? "Your organization's full name is required." : ''}
                                    />
                                </div>
                                <div className="col-12 col-lg-6 my-2">
                                    <TextField
                                        fullWidth
                                        id="organizationShortName"
                                        label="Organization Short Name"
                                        name="Organization Short Name"
                                        defaultValue={organizationShortName}
                                        variant="outlined"
                                        onChange={e => setOrganizationShortName(e.target.value)}
                                    />
                                </div>
                                <div className="col-12 my-2">
                                    <TextField
                                        required
                                        fullWidth
                                        id="organizationAddress"
                                        label="Organization Address"
                                        name="Organization Address"
                                        autoComplete="street-address"
                                        variant="outlined"
                                        onChange={e => setAddress(e.target.value)}
                                        error={invalidAddress}
                                        helperText={invalidAddress ? "Your organization's street address is required." : ''}
                                    />
                                </div>
                                <div className="col-12 col-lg-6 my-2">
                                    <TextField
                                        required
                                        fullWidth
                                        name="City"
                                        label="City"
                                        id="City"
                                        autoComplete="address-level2"
                                        variant="outlined"
                                        onChange={e => setCity(e.target.value)}
                                        error={invalidCity}
                                        helperText={invalidCity ? "Your organization's city is required." : ''}
                                    />
                                </div>
                                <div className="col-12 col-lg-6 my-2">
                                    <TextField
                                        required
                                        fullWidth
                                        name="Zip Code"
                                        label="Zip Code"
                                        id="zipCode"
                                        autoComplete="postal-code"
                                        variant="outlined"
                                        onChange={e => setZip(e.target.value)}
                                        error={invalidZip}
                                        helperText={invalidZip ? "Your organization's zip code is required." : ''}
                                    />
                                </div>
                                <div className="col-12 my-2">
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        sx={{ mt: 3, mb: 2 }}
                                        onClick={() => {
                                            handleContinueButtonClick()
                                        }}
                                    >
                                        Continue
                                    </Button>
                                </div>
                            </div>
                            <Copyright sx={{ mt: 5 }} />
                        </Box>
                    </Grid>
                    : screenType == 'create' && selectedStaffProfile != null ?
                        <Grid item xs={12} component={Paper} sx={{ backgroundColor: 'white', zIndex: 1 }} elevation={6} square>
                            <Box
                                sx={{
                                    my: 8,
                                    mx: 5,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center'
                                }}
                            >
                                <Typography variant="h3" className="mt-5">
                                    Your Organization
                                </Typography>
                                <Typography variant="body1" className="mb-5">
                                    You've already registered your organization. In order to start using Latent with your organization, you'll need to select a subscription plan from the "Subscription" page.
                                </Typography>
                                <div className="row w-100">
                                    <div className="col-12 col-lg-6 my-2">
                                        <MuiPhoneNumber
                                            disabled
                                            defaultCountry={'us'}
                                            name="phoneNumber"
                                            type="tel"
                                            countryCodeEditable={false}
                                            value={phoneNumber}
                                            onChange={(e) => { console.log(e); if (typeof e == 'string' && isValidPhoneNumber(e)) setPhoneNumber(parsePhoneNumber(e).number); else setPhoneNumber(undefined) }}
                                            variant="outlined"
                                            placeholder="Organization Phone Number"
                                            required
                                            fullWidth
                                            label="Organization Phone Number"
                                            error={invalidOrganizationPhoneNumber}
                                            helperText={invalidOrganizationPhoneNumber ? "Your organization's primary contact phone number is required." : ''}
                                        />
                                    </div>
                                    <div className="col-12 col-lg-6 my-2">
                                        <TextField
                                            disabled
                                            fullWidth
                                            name="Website"
                                            label="Website"
                                            id="Website"
                                            autoComplete="url"
                                            variant="outlined"
                                            value={website}
                                            onChange={e => setWebsite(e.target.value)}
                                            error={invalidWebsite}
                                            helperText={invalidWebsite ? "Your organization's website is required. A social media page will work if you don't have a dedicated website." : ''}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </div>
                                    <div className="col-12 col-lg-6 my-2">
                                        <TextField
                                            disabled
                                            required
                                            fullWidth
                                            id="organizationName"
                                            label="Organization Name"
                                            name="Organization Name"
                                            defaultValue={organizationName}
                                            autoComplete="organization"
                                            variant="outlined"
                                            value={organizationName}
                                            onChange={e => setOrganizationName(e.target.value)}
                                            error={invalidOrganizationName}
                                            helperText={invalidOrganizationName ? "Your organization's full name is required." : ''}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </div>
                                    <div className="col-12 col-lg-6 my-2">
                                        <TextField
                                            disabled
                                            fullWidth
                                            id="organizationShortName"
                                            label="Organization Short Name"
                                            name="Organization Short Name"
                                            value={organizationShortName}
                                            variant="outlined"
                                            onChange={e => setOrganizationShortName(e.target.value)}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </div>
                                    <div className="col-12 my-2">
                                        <TextField
                                            disabled
                                            required
                                            fullWidth
                                            id="organizationAddress"
                                            label="Organization Address"
                                            name="Organization Address"
                                            autoComplete="street-address"
                                            variant="outlined"
                                            value={address}
                                            onChange={e => setAddress(e.target.value)}
                                            error={invalidAddress}
                                            helperText={invalidAddress ? "Your organization's street address is required." : ''}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </div>
                                    <div className="col-12 col-lg-6 my-2">
                                        <TextField
                                            disabled
                                            required
                                            fullWidth
                                            name="City"
                                            label="City"
                                            id="City"
                                            autoComplete="address-level2"
                                            variant="outlined"
                                            value={city}
                                            onChange={e => setCity(e.target.value)}
                                            error={invalidCity}
                                            helperText={invalidCity ? "Your organization's city is required." : ''}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </div>
                                    <div className="col-12 col-lg-6 my-2">
                                        <TextField
                                            disabled
                                            required
                                            fullWidth
                                            name="Zip Code"
                                            label="Zip Code"
                                            id="zipCode"
                                            autoComplete="postal-code"
                                            variant="outlined"
                                            value={zip}
                                            onChange={e => setZip(e.target.value)}
                                            error={invalidZip}
                                            helperText={invalidZip ? "Your organization's zip code is required." : ''}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </div>
                                    <div className="col-12 my-5 d-flex flex-row justify-content-center">
                                        <Typography variant="body1">
                                            If you need to change any of these attributes, contact our support team.
                                        </Typography>
                                    </div>
                                </div>
                                <Copyright sx={{ mt: 5 }} />
                            </Box>
                        </Grid>
                        : screenType == 'select-subscription' ?
                            <Grid container xs={12} sm={12} lg={12} component={Paper} sx={{ backgroundColor: 'white', zIndex: 1 }} padding={2} elevation={6} square>
                                <Box
                                    sx={{
                                        my: 8,
                                        mx: 2,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        width: '100%'
                                    }}
                                >
                                    <div className="d-flex flex-row justify-content-center align-items-center">
                                        <img src={logo} style={{ height: 40, color: 'black' }} />
                                        <p style={{ fontSize: 36, fontFamily: 'Gilroy-Bold', color: 'black', padding: 0, margin: 0, marginLeft: 10 }}>Latent</p>
                                    </div>
                                    <Typography variant="h3" className="my-5">
                                        Select your subscription plan
                                    </Typography>
                                    <Typography className="mx-2">Contact our sales team if you want to see a demo or ask questions before selecting a subscription package. In order to start using Latent, you'll need to start a subscription plan.</Typography>
                                </Box>
                                {tiers.map((tier) => (
                                    // Enterprise card is full width at sm breakpoint
                                    <Grid
                                        item
                                        key={tier.title}
                                        xs={12}
                                        sm={tier.title === 'Enterprise' ? 12 : 6}
                                        md={4}
                                    >
                                        <Card className="shadow m-1">
                                            <CardHeader
                                                title={tier.title}
                                                subheader={tier.subheader}
                                                titleTypographyProps={{ align: 'center' }}
                                                // action={tier.title === 'Pro' ? <StarIcon /> : null}
                                                subheaderTypographyProps={{
                                                    align: 'center',
                                                    color: 'lightgray'
                                                }}
                                                sx={{
                                                    backgroundColor: 'black',
                                                    color: 'white'
                                                }}
                                            />
                                            <CardContent>
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'baseline',
                                                        mb: 2,
                                                    }}
                                                >
                                                    <Typography component="h2" variant="h3" color="text.primary">
                                                        ${tier.price}
                                                    </Typography>
                                                    <Typography variant="h6" color="text.secondary">
                                                        /mo
                                                    </Typography>
                                                </Box>
                                                <ul>
                                                    {tier.description.map((line) => (
                                                        <Typography
                                                            component="li"
                                                            variant="subtitle1"
                                                            align="center"
                                                            key={line}
                                                        >
                                                            {line}
                                                        </Typography>
                                                    ))}
                                                </ul>
                                            </CardContent>
                                            <CardActions>
                                                <Button
                                                    fullWidth
                                                    variant={tier.buttonVariant as 'outlined' | 'contained'}
                                                >
                                                    {tier.buttonText}
                                                </Button>
                                            </CardActions>
                                        </Card>
                                    </Grid>
                                ))}
                                <Button fullWidth variant="text" className="my-3" onClick={() => { history.push('/admin/dashboard') }}>Or skip for now</Button>
                            </Grid>
                            :
                            <div />
            }
        </Grid >
    );
}